export default {"src":"/_next/static/media/34.237cb442.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};